import { render, staticRenderFns } from "./PesquisarCliente.vue?vue&type=template&id=e288ace4&"
import script from "./PesquisarCliente.vue?vue&type=script&lang=js&"
export * from "./PesquisarCliente.vue?vue&type=script&lang=js&"
import style0 from "./PesquisarCliente.vue?vue&type=style&index=0&id=e288ace4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports